
import { clearLocalStorage } from '../auth/localStorage';

export default (state = { loading: false, error:false }, action) => {

  switch (action.type) {
    case 'LOGIN_BEGIN':
      return { ...state, loading: true };
    case 'LOGIN_SUCCESS':
      return { ...state, user: action.payload, loading: false, error: action.payload.status === 'failed' };
    case 'CLEAR_LOGIN':
      return { ...state, user: null, loading: false };
    case 'LOGOUT':
      clearLocalStorage();
      return { ...state, user: null, loading: false };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/login/loginReducers.js